import styled from '@emotion/styled';

export const RoundIconContainer = styled('div')<{
  size?: 'small' | 'medium';
  backgroundShade?: 'light' | 'main' | 'dark';
}>((p) => ({
  backgroundColor: p.theme.palette.primary[p.backgroundShade ?? 'light'],
  color: p.theme.palette.primary.contrastText,
  padding: p.theme.spacing(p.size === 'small' ? 0.75 : 1.25),
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}));
